import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { environment } from '../environments/environment';
import { AngularFireDatabaseModule } from'angularfire2/database';


import { AppComponent } from './app.component';
import { AgmCoreModule } from '@agm/core';
import { ResaltarDirective } from "./directives/resaltar.directive";
import { ContarClicksDirective } from "./directives/contar-clicks.directive";
import { DetalleComponent } from './detalle/detalle.component';
import { LugaresComponent } from './lugares/lugares.component';
import { ContactoComponent } from './contacto/contacto.component';
import { LugaresService } from './services/lugares.service';
import { MyGuardService } from './services/myguard.service';
import { AutorizacionService } from './services/autorizacion.service';

import { CrearComponent } from './crear/crear.component';
import { HttpModule } from '@angular/http';
import { LinkifyPipe } from './linkify.pipe';
import { LoginComponent } from './login/login.component';
import { RegistroComponent } from './registro/registro.component';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { NosotrosComponent } from './nosotros/nosotros.component';

const appRoutes: Routes = [
{path:'', component: HomeComponent},
{path:'home', component: HomeComponent},
{path:'nosotros', component: NosotrosComponent},
{path:'lugares', component: LugaresComponent},
{path:'detalle/:id', component: DetalleComponent},
{path:'contacto', component: ContactoComponent},
{path:'crear/:id', component: CrearComponent, canActivate:[MyGuardService]},
{path:'registro', component: RegistroComponent},
{path:'login', component: LoginComponent}
];

@NgModule({
  declarations: [
    AppComponent,
    ResaltarDirective,
    ContarClicksDirective,
    DetalleComponent,
    LugaresComponent,
    ContactoComponent,
    CrearComponent,
    LinkifyPipe,
    LoginComponent,
    RegistroComponent,
    HomeComponent,
    NosotrosComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AgmCoreModule.forRoot({apiKey: 'AIzaSyBdRg7u9BEEv5k1A68ZLfuRsICfD6pq6hY'}),
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    HttpModule,
    ReactiveFormsModule
  ],
  providers: [LugaresService, AutorizacionService, MyGuardService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/app.module.ts